import BaseModelComponent from "../../../../base/base_model_component";
import {ICON_TYPE} from "./sweden_responsible_gaming_consts";



class SwedenResponsibleGamingIconsModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'SwedenResponsibleGamingIconsModel';

    /**
     *
     * @param params
     */
    init(params = {}) {
        super.init(params);
        this._setIconType(params.iconType);
    }


    /**
     * Set icon type to be displayed (
     * @param iconType
     * Full view with text and symbol = text
     * symbol only = symbol
     * @returns {SwedenResponsibleGamingIconsModel}
     * @private
     */
    _setIconType(iconType = ICON_TYPE.TEXT) {
        this._iconType = iconType;
        return this;
    }


    /**
     * Get icon type to be displayed
     * @returns {string|*}
     */
    getIconType() {
        return this._iconType;
    }

}

export default SwedenResponsibleGamingIconsModel;